import React from "react";
import { Button } from "../../Button";
import Modal from "../../DialogModal/DialogModal";

interface Props {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  onPrimaryAction: () => void;
  primaryBtnText?: string;
  title?: string;
  secondaryBtnText?: string;
  onSecondaryAction?: () => void;
  content: string;
}

export const DonateConfirmationModal: React.FC<Props> = ({
  content,
  isLoading,
  isOpen,
  onClose,
  onPrimaryAction,
  onSecondaryAction = onClose,
  primaryBtnText = "Confirm payment",
  secondaryBtnText = "Cancel",
  title = "Payment confirmation",
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => !isLoading && onClose()}
        title={title}
      >
        <>
          <p
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />

          <div style={{ flex: "1 0 auto", marginTop: "16px" }}>
            <Button
              disabled={isLoading}
              extra={{ style: { marginRight: "15px" } }}
              loading={isLoading}
              primary
              onClick={onPrimaryAction}
              text={primaryBtnText}
            />
            <Button
              loading={isLoading}
              disabled={isLoading}
              textOnly
              onClick={onSecondaryAction}
              text={secondaryBtnText}
            />
          </div>
        </>
      </Modal>
    </>
  );
};
